/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ProjectUpdateAccessLevel } from './projectUpdateAccessLevel';
import type { ProjectUpdateStatus } from './projectUpdateStatus';

export interface ProjectUpdate {
  title?: string | null;
  description?: string | null;
  status?: ProjectUpdateStatus;
  access_level?: ProjectUpdateAccessLevel;
  collaborator_ids?: string[] | null;
}
